const SAVE_CONTACT_INFO_DATA_START = 'SAVE_CONTACT_INFO_DATA_START';
const SAVE_CONTACT_INFO_DATA_SUCCESS = 'SAVE_CONTACT_INFO_DATA_SUCCESS';
const SAVE_CONTACT_INFO_DATA_ERROR = 'SAVE_CONTACT_INFO_DATA_ERROR';
const GET_CONTACT_INFO_DATA_START='GET_CONTACT_INFO_DATA_START';
const GET_CONTACT_INFO_DATA_SUCCESS='GET_CONTACT_INFO_DATA_SUCCESS';
const GET_CONTACT_INFO_DATA_ERROR='GET_CONTACT_INFO_DATA_ERROR';

const setContactInfoStart = () => {
	console.log("working 1")
	return {
		type: SAVE_CONTACT_INFO_DATA_START,
	};
};

const setContactInfoSuccess = (res) => {
	return {
		type: SAVE_CONTACT_INFO_DATA_SUCCESS, 
		res
	};
};

const setContactInfoError = () => {
	return {
		type: SAVE_CONTACT_INFO_DATA_ERROR,
	};
};


const getContactInfoStart = () => {
	console.log("working 2")
	return {
		type: GET_CONTACT_INFO_DATA_START,
	};
};

const getContactInfoSuccess = (res) => {
	return {
		type: GET_CONTACT_INFO_DATA_SUCCESS, 
		res
	};
};

const getContactInfoError = () => {
	return {
		type: GET_CONTACT_INFO_DATA_ERROR,
	};
};

export default {
	types: {
		SAVE_CONTACT_INFO_DATA_START ,
		SAVE_CONTACT_INFO_DATA_SUCCESS,
		SAVE_CONTACT_INFO_DATA_ERROR,
		GET_CONTACT_INFO_DATA_START,
		GET_CONTACT_INFO_DATA_SUCCESS,
		GET_CONTACT_INFO_DATA_ERROR

	},
	creators: {
		setContactInfoStart,
		setContactInfoSuccess,
		setContactInfoError,
		getContactInfoStart,
		getContactInfoSuccess,
		getContactInfoError
	},
};
